import { render, staticRenderFns } from "./editar-envio.vue?vue&type=template&id=1231c80a&scoped=true&"
import script from "./editar-envio.vue?vue&type=script&lang=ts&"
export * from "./editar-envio.vue?vue&type=script&lang=ts&"
import style0 from "./editar-envio.vue?vue&type=style&index=0&id=1231c80a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1231c80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VRow,VTextField})
